import { DateRangeFieldComponent } from '../../../Reports/components/DateRangeField/date-range-field.component';
import { SeriresCountFieldComponent } from '../../../Reports/components/SeriesCountField/series-count-field.component';
import { ReportBlockTypeEnum } from '../../../Reports/enums/report-block-type.enum';
import { SeriesTypeEnum } from '../../../Reports/enums/series-type.enum';
import { ChartDisplayElementModel } from '../../../Reports/models/chart-display-element.model';
import { DateRangeFieldModel } from '../../../Reports/models/date-range-field.model';

import { ColorPickerByCountFieldComponent } from '../../../PageBuilder/components/FormFields/ColorPickerByCountField/color-picker-by-count-field.component';
import { TextFieldComponent } from '../../../PageBuilder/components/FormFields/TextField/text-field.component';
import { BlockTypeModel } from '../../../PageBuilder/models/block-type.model';
import { ColorCheckboxesFieldModel } from '../../../PageBuilder/models/color-checkboxes-field.model';
import { SeriesCountFieldModel } from '../../../PageBuilder/models/series-count-field.model';
import { TextFieldModel } from '../../../PageBuilder/models/text-field.model';
import { DashboardChartBlockComponent } from '../../../Dashboard/components/DashboardChartBlock/dashboard-chart-block.component';
import { StaticTextHeadingFieldModel } from '../../../PageBuilder/models/static-text-heading-field.model';
import { StaticTextHeadingFieldComponent } from '../../../PageBuilder/components/FormFields/StaticTextHeadingField/static-text-heading-field.component';
import { ChartDisplaySettingsFieldModel } from '../../../Reports/models/chart-display-settings-field.model';
// eslint-disable-next-line max-len
import { ChartDisplaySettingsFieldComponent } from '../../../Reports/components/ChartDisplaySettingsField/chart-display-settings-field.component';
import { ChartHeaderElementsEnum } from '../../../Charts/models/chart-display-settings.model';

// Recent Topic Activity
export const recentTopicActivityBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.RECENT_TOPICS,
    `Dashboard.chart.title.${ReportBlockTypeEnum.RECENT_TOPICS}`,
    'fa-regular fa-duotone fa-chart-column',
    null,
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new SeriesCountFieldModel(
            SeriresCountFieldComponent,
            'seriesCount',
            'Dashboard.manageChart.numberOfTopics',
            1,
            8,
            4,
            SeriesTypeEnum.topic
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            '',
            false
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings'
        ),
        new ColorCheckboxesFieldModel(
            ColorPickerByCountFieldComponent,
            'series',
            '',
            '',
            [],
            null
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            '',
            [ChartHeaderElementsEnum.TITLE, ChartHeaderElementsEnum.DATE]
        )
    ],
    DashboardChartBlockComponent
);
